// ##### 24-06-12 Komarov
import React from 'react';
import { Media } from '../../../../../helpers/MediaConfig';
// ##### 25-05-21 Komarov
import CurrencyAndLanguageSelectionTools from './CurrencyAndLanguageSelectionTools';
import TopMenuRightDiv from './TopMenuRightDiv';

// ##### Komarov 2025-07-14
const HeaderClassDiv = ({ headerClass }) => {
  // ##### Komarov 2025-07-23
  return (
    <div className={headerClass} data-component="HeaderClassDivSsr">
      {/* ##### 23-11-01 Komarov */}
      <Media lessThan="Laptop-1024-1440">
        <TopMenuRightDiv className="topMenu_right_mobile" />
      </Media>
      {/* ##### 23-11-01 Komarov */}
      <Media greaterThanOrEqual="Laptop-1024-1440">
        <TopMenuRightDiv className="topMenu_right" />
      </Media>
      <Media lessThan="Laptop-1024-1440">
        <CurrencyAndLanguageSelectionTools className="LangCurrencyMobileLandscape" />
      </Media>
    </div>
  );
};

export default HeaderClassDiv;
